export const debugPresets = {
    'Smoke': {
        shape: 'spiral', shapeText: 'SMOKE', shapeScale: 2.6,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0, particleShape: 3, shapeSoftness: 0.85,
        particleColor: '#3f4864', colorShift: '#e1e0ff', backgroundColor: '#000000',
        opacityVariance: 0.3, colorVariance: 0.65, sizeVariance: 1.09,
        flashIntensity: 1.5, dimIntensity: 4.78, saturation: 1,
        flowInfluence: 0.15, flowStrength: 0.4, flowFrequency: 0.3,
        mouseRadius: 6, mouseAspect: 1.8, suckStrength: 9.8, alwaysSuck: true, windStrength: 5, mouseTrail: 0.41,
        particleCount: 685000, respawnRate: 0.07,
        damping: 2.5, turbulenceStrength: 0.6, turbulenceFrequency: 0.8,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.54, bloomRadius: 1.63, bloomThreshold: 0.88,
        trailEnabled: true, trailAmount: 15.2, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 1,
        revealEnabled: false, revealRadius: 9.4, revealSoftness: 0.15,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
    'Smoke 2': {
        shape: 'sphere', shapeText: 'SMOKE', shapeScale: 1.1,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0, particleShape: 0, shapeSoftness: 0.85,
        particleColor: '#3f4864', colorShift: '#e1e0ff', backgroundColor: '#000000',
        opacityVariance: 0.92, colorVariance: 0.6, sizeVariance: 1.09,
        flashIntensity: 0, dimIntensity: 6.52, saturation: 1,
        flowInfluence: 0.15, flowStrength: 0.4, flowFrequency: 0.3,
        mouseRadius: 4.9, mouseAspect: 1.8, suckStrength: 6.5, alwaysSuck: true, windStrength: 5, mouseTrail: 0,
        particleCount: 240000, respawnRate: 0.4,
        damping: 1.6, turbulenceStrength: 2.9, turbulenceFrequency: 0.7,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.54, bloomRadius: 1.63, bloomThreshold: 0.88,
        trailEnabled: true, trailAmount: 60.8, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 1,
        revealEnabled: false, revealRadius: 9.4, revealSoftness: 0.15,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
    // Pagina carbon.html — derivato da Vik 5: aspirazione dal basso verso l'alto,
    // corrente ascensionale costante e zone di esclusione attorno ai testi
    'Carbon': {
        shape: 'field', shapeText: 'SMOKE', shapeScale: 1.0,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.05, morphStrength: 5,
        particleSize: 0.006, particleShape: 0, shapeSoftness: 0,
        particleColor: '#d5d5d5', colorShift: '#d4f1fe', backgroundColor: '#000000',
        opacityVariance: 0, colorVariance: 0.5, sizeVariance: 3.85,
        flashIntensity: 0.3, dimIntensity: 0, saturation: 1.57,
        flowInfluence: 0.76, flowStrength: 14.307, flowFrequency: 1.2,
        mouseRadius: 6, mouseAspect: 1.8, suckStrength: 50, alwaysSuck: false, clickSuckEnabled: false, windStrength: 15.2, mouseTrail: 0,
        particleCount: 25000, respawnRate: 0.15, spawnEdgeBias: 0.3, spawnEdgeFloor: 0.15,
        damping: 3.3, turbulenceStrength: 25.4, turbulenceFrequency: 1.7,
        forceGradEnabled: true, forceGradFloor: 0.06, forceGradVertical: 0.47, forceGradHorizontal: 0.0, forceGradPower: 0.2,
        symmetricField: true,
        updraftStrength: -1.0,
        pathEnabled: false, pathKinematic: false, flatten2D: false,
        pathAttraction: 1.2, pathDriftSpeed: 2.5, pathDriftRate: 6,
        pathWaveFreq: 0.35, pathWaveAmp: 0.9, pathWaveSpeed: 0.6,
        pathSpiralFreq: 0.8, pathRadius: 0.45,
        textAvoidStrength: 33, textAvoidRadius: 3.2, textAvoidPadding: 36, textCorePadding: 8, textAvoidTip: 1.6,
        textAvoidTipDown: 4.5,
        textTipAttract: 0, textTipAttractRadius: 10, textAvoidSolid: false, textDodge: false,
        spawnNoiseFreq: 0.3, spawnNoiseSpeed: 0.4, spawnNoiseAmp: 0, spawnNoiseGate: -1,
        enableZoom: false, enablePan: false, enableRotate: false,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.75, bloomRadius: 0, bloomThreshold: 0.36,
        trailEnabled: true, trailAmount: 60.7, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0.22, trailBlendMode: 0,
        dofEnabled: false, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 0.1,
        suctionBarsEnabled: true, suctionBarStrength: 13, suctionBarRadius: 30, suctionFadeSpeed: 1.975,
        suctionKillFactor: 0.12,
        suctionBar0Pos: { x: 6.13, y: -7.45, z: 0 },
        suctionBar0Size: { x: 3, y: 0.4, z: 1 },
        suctionBar1Pos: { x: -6.13, y: -7.45, z: 0 },
        suctionBar1Size: { x: 3, y: 0.4, z: 1 },
        revealEnabled: false, revealRadius: 17.9, revealSoftness: 0.9,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
    'Vik 5': {
        shape: 'field', shapeText: 'SMOKE', shapeScale: 1.0,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.05, morphStrength: 5,
        particleSize: 0.006, particleShape: 0, shapeSoftness: 0,
        particleColor: '#d5d5d5', colorShift: '#d4f1fe', backgroundColor: '#000000',
        opacityVariance: 0, colorVariance: 0.5, sizeVariance: 3.85,
        flashIntensity: 0.3, dimIntensity: 0, saturation: 1.57,
        flowInfluence: 0.76, flowStrength: 14.307, flowFrequency: 0.7,
        mouseRadius: 6, mouseAspect: 1.8, suckStrength: 50, alwaysSuck: false, windStrength: 15.2, mouseTrail: 0,
        particleCount: 20000, respawnRate: 0.25,
        damping: 2.9, turbulenceStrength: 11.4, turbulenceFrequency: 7.4,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.75, bloomRadius: 0, bloomThreshold: 0.36,
        trailEnabled: true, trailAmount: 60.7, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0.22, trailBlendMode: 0,
        dofEnabled: false, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 0.1,
        suctionBarsEnabled: true, suctionBarStrength: 48, suctionBarRadius: 12.1, suctionFadeSpeed: 1.975,
        suctionBar0Pos: { x: -11.876878155664922, y: 0, z: 0 },
        suctionBar0Size: { x: 0.3, y: 5, z: 0.5 },
        suctionBar1Pos: { x: 11.612455360927239, y: 0, z: 0 },
        suctionBar1Size: { x: 0.3, y: 5, z: 0.5 },
        revealEnabled: false, revealRadius: 17.9, revealSoftness: 0.9,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
}
